const formatInstitutionToState = ({ general, features, launchDarkly }) => {
  const endpoints = {
    api: `https://api.${general.base_domain}`,
  };

  return {
    general,
    name: general.display_name,
    keys: {
      endpoints,
    },
    features,
    launchDarkly,
  };
};

export default formatInstitutionToState;
